(function () {
  var cfg = window.AcrylicBundle;
  if (!cfg) return;

  // Offer ends: May 19, 2026 11:59pm AEST
  var END_MS = new Date('2026-05-19T23:59:59+10:00').getTime();

  waitForForm();

  function waitForForm() {
    var form = findForm();
    if (form) { inject(form); return; }
    var observer = new MutationObserver(function (_, obs) {
      var f = findForm();
      if (f) { obs.disconnect(); inject(f); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 8000);
  }

  function findForm() {
    return document.querySelector('form[action="/cart/add"]') ||
           document.querySelector('form[action*="cart/add"]');
  }

  function inject(form) {
    if (document.getElementById('ab-hint')) return;

    var hint = document.createElement('div');
    hint.id = 'ab-hint';
    hint.innerHTML = buildHintHtml();

    var btn = form.querySelector('[name="add"], button[type="submit"]');
    if (btn) { form.insertBefore(hint, btn); }
    else { form.appendChild(hint); }

    tick();
    var timer = setInterval(tick, 1000);

    function tick() {
      var diff = END_MS - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        var el = document.getElementById('ab-hint');
        if (el) el.parentNode.removeChild(el);
        return;
      }
      var days  = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins  = Math.floor((diff % 3600000) / 60000);
      var secs  = Math.floor((diff % 60000) / 1000);
      var el = document.getElementById('ab-cd-val');
      if (el) {
        el.innerHTML =
          '<span class="ab-cd-unit">' + pad(days)  + '<em>d</em></span>' +
          '<span class="ab-cd-unit">' + pad(hours) + '<em>h</em></span>' +
          '<span class="ab-cd-unit">' + pad(mins)  + '<em>m</em></span>' +
          '<span class="ab-cd-unit">' + pad(secs)  + '<em>s</em></span>';
      }
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
  }

  function buildHintHtml() {
    return '<div class="ab-hint-row">'
      + '<span class="ab-badge">LAUNCH SPECIAL</span>'
      + '<div class="ab-hint-body">'
      + '<span class="ab-hint-text">35&#37; off your second block &mdash; applied at checkout.</span>'
      + '<span class="ab-hint-cd">Ends in&nbsp;<span id="ab-cd-val" class="ab-cd-val"></span></span>'
      + '</div>'
      + '</div>'
      + '<style>'
      + '#ab-hint{margin:0 0 14px;}'
      + '.ab-hint-row{display:flex;align-items:center;gap:11px;padding:10px 14px;background:#f7f7f7;border-radius:6px;border:1px solid #e8e8e8;}'
      + '.ab-badge{background:#111;color:#fff;font-size:9px;font-weight:700;letter-spacing:.1em;padding:3px 8px;border-radius:4px;white-space:nowrap;text-transform:uppercase;flex-shrink:0;}'
      + '.ab-hint-body{display:flex;flex-direction:column;gap:3px;}'
      + '.ab-hint-text{font-size:13px;color:#333;line-height:1.3;}'
      + '.ab-hint-cd{font-size:11px;color:#333;letter-spacing:.01em;}'
      + '.ab-cd-val{display:inline-flex;gap:5px;}'
      + '.ab-cd-unit{font-variant-numeric:tabular-nums;font-size:11px;color:#333;font-weight:600;letter-spacing:.02em;}'
      + '.ab-cd-unit em{font-style:normal;font-weight:600;color:#333;margin-left:1px;}'
      + '</style>';
  }
})();
